import {
  Button,
  Checkbox,
  Grid,
  InputAdornment,
  Stack,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { ErrorMessage, Formik } from "formik";
import React from "react";
import { useStyles } from "./styles";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import * as Yup from "yup";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Login_Img from "../../assets/images/Login/login.svg";
import Logo from "../../assets/images/Login/logo.svg";
import useAuthStore from "../../Hooks/auth";
import { useNavigate } from "react-router-dom";

const LoginSchema = Yup.object().shape({
  username: Yup.string().required("* Please enter Username"),
  password: Yup.string().required("* Please enter password"),
});

const Login = (props) => {
  const { loginAction, isAuth, loading, resetAuthAction, token, logoutAction } =
    useAuthStore();
  const [showPassword, setShowPassword] = React.useState(false);
  const navigate = useNavigate();

  const initValues = {
    username: "",
    password: "",
  };

  React.useEffect(() => {
    if (isAuth == true) {
      navigate("/");
    }
  }, [isAuth]);

  React.useEffect(() => {
    if (!token || token === null) {
      logoutAction();
    }
  }, [token]);

  const classes = useStyles();
  return (
    <Stack>
      <Grid container className={classes.login}>
        <Grid item md={6} className={classes.login_left}>
          <img src={Login_Img} alt={"login"} />
          <Stack className={classes.logo_container}>
            <img src={Logo} alt="College Connect" />
          </Stack>
        </Grid>
        <Grid
          item
          md={6}
          className={classes.login_right}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Stack>
            <Typography className={classes.sign_in} sx={{ pb: 2 }}>
              Sign In
            </Typography>
          </Stack>
          <Stack className={classes.formContainer}>
            <Formik
              validationSchema={LoginSchema}
              initialValues={initValues}
              validateOnBlur={false}
              validateOnChange={false}
              onSubmit={(values) => loginAction(values)}
            >
              {(formik) => {
                const {
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  values,
                } = formik;
                return (
                  <form onSubmit={handleSubmit}>
                    <Stack sx={{ pb: 3 }}>
                      <Typography
                        sx={{ pb: 1 }}
                        className={classes.input_label}
                      >
                        User Name
                      </Typography>
                      <TextField
                        id="username"
                        name="username"
                        placeholder="Enter user name"
                        className={
                          errors.username && touched.username
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <PersonIcon />
                            </InputAdornment>
                          ),
                        }}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.username}
                      />
                      <ErrorMessage
                        name="username"
                        component="span"
                        className={classes.error}
                      />
                    </Stack>
                    <Stack>
                      <Typography
                        sx={{ pb: 1 }}
                        className={classes.input_label}
                      >
                        Password
                      </Typography>
                      <TextField
                        id="password"
                        name="password"
                        placeholder="Enter password"
                        className={
                          errors.password && touched.password
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        type={showPassword ? "text" : "password"}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <LockIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment
                              position="start"
                              sx={{ cursor: "pointer" }}
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </InputAdornment>
                          ),
                        }}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.password}
                      />
                      <ErrorMessage
                        name="password"
                        component="span"
                        className={classes.error}
                      />
                    </Stack>
                    <Stack
                      sx={{
                        justifyContent: "flex-end",
                        flexDirection: "row",
                        alignItems: "center",
                        py: 2,
                      }}
                    >
                      <Stack
                        sx={{
                          fontSize: "18px",
                          color: "#1E8BB0",
                          cursor: "pointer",
                        }}
                      >
                        <em onClick={() => navigate("/forgotpassword")}>
                          Forgot Password?
                        </em>
                      </Stack>
                    </Stack>
                    <Button
                      type="submit"
                      sx={{
                        width: "100%",
                        px: 1,
                        py: 2,
                        borderRadius: "50px",
                        fontSize: "15px",
                      }}
                      className={classes.submit_btn}
                      disabled={loading}
                    >
                      {loading ? (
                        <CircularProgress
                          size={25}
                          style={{ color: "#0b3b4b" }}
                        />
                      ) : (
                        "Sign In"
                      )}
                    </Button>
                  </form>
                );
              }}
            </Formik>
          </Stack>
          <Stack sx={{justificationContent:'center', alignItems:'center'}}>
            <Typography sx={{
              pb: 2, position: 'absolute', bottom: 0,
              fontSize: '10px !important',
              color: '#747070',
              fontWeight:"600",
             }}
              variant="p" alignCenter display="block">
              @{new Date().getFullYear()} HUBINO TECHNOLOGIES PRIVATE LIMITED. All Rights Reserved. <span
                onClick={() => navigate("/privacy")}
                style={{ cursor: "pointer", color:'#25d5a1' }}
              >
                Privacy Policy
              </span>
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default Login;
